<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <PageTitle :title="companyName"/>
        <small><a :href="url" target="_blank">{{url}}</a></small>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import PageTitle from "../atoms/PageTitle";
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "organism",
    name: "CompanyStatus",
    props: {
      user: {
        type: Object,
        required: true
      },
      company: {
          type: Object,
          required: true
      }
    },
    computed: {
      companyName () {
        return this.company ? this.company.name : ""
      },
      registerDate () {
        return this.user ? this.dateToText(this.user.dateJoined) : ""
      },
      url () {
        return this.company ? this.company.url : ""
      }
    },
    components: {
      PageTitle
    }
  }
</script>

<style scoped lang="sass">
.medal
  margin-right: 16px
  .v-icon
    &.gold
      color: gold
    &.silver
      color: silver
    &.bronze
      color: #cd7f32


</style>
